<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">

      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <p class="p-login">{{ $t('correo') }}</p>
                  <b-form-input alternative class="mb-3" name="Email"
                    @input="showError = false; isPasswordValid = null;" :rules="{ required: true, email: true }"
                    :state="isPasswordValid" prepend-icon="ni ni-email-83" :placeholder="$t('correo')"
                    v-model="form.username"></b-form-input>
                  <b-form-invalid-feedback>
                  </b-form-invalid-feedback>

                  <p class="p-login">{{ $t('contrasena') }}</p>
                  <b-form-input alternative class="mb-3" name="Password" :rules="{ required: true, min: 5 }"
                    prepend-icon="ni ni-lock-circle-open" type="password" v-model="form.password"
                    :state="isPasswordValid" :placeholder="$t('contrasena')"
                    @input="showError = false; isPasswordValid = null;"></b-form-input>
                  <b-form-invalid-feedback>
                    <h3 class="text-center mb-2">
                      <b-badge variant="danger">
                        {{ $t('credenciales_invalidas') }}
                      </b-badge>
                    </h3>
                  </b-form-invalid-feedback>

                  <div class="text-right mt-1">
                    <router-link to="/auth/request-password-reset" class="text-black">
                      <small>{{ $t('olvide_contrasena') }}</small>
                    </router-link>
                  </div>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">{{ $t('iniciar_sesion') }}</base-button>
                  </div>

                  <!-- <div class="text-center mt-2">
                    <router-link to="/register" class="text-black d-block">
                      <small>{{ $t('sin_cuenta') }}</small>
                    </router-link>
                  </div> -->

                </b-form>
              </validation-observer>
            </b-card-body>

          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import authService from '@/api/authService';
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      showError: false,
      isPasswordValid: null,
    };
  },
  methods: {
    async onSubmit() {
      try {
        Swal.fire({
          html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('iniciando')}</h3>
                        </div>
                    </div>`,
          showConfirmButton: false,
          allowOutsideClick: false
        });
        const response = await authService.login(this.form);
        if (!response) throw new Error('Credenciales inválidas.');
        
        // Obtener el rol del usuario desde el token
        const token = localStorage.getItem('user-session');
        if (token) {
          const decoded = JSON.parse(atob(token.split('.')[1]));
          const userRole = (decoded.rol || '').toLowerCase().trim();
          
          // Redirigir según el rol
          if (userRole === 'comprador') {
            this.$router.push({ name: 'visor-transacciones' });
          } else {
            this.$router.push({ name: 'dashboard-master' });
          }
        } else {
          this.$router.push({ name: 'dashboard-master' });
        }
        
        Swal.close();
      } catch (error) {
        Swal.close();
        this.showError = true;
        this.isPasswordValid = false;
      }


    }
  }
};
</script>

<style>
.p-login {
  margin-bottom: 0;
}
</style>